import { ParentalControlRating, Profile } from 'store/user/reducer.types';

function getParentalRating(
    userParentalRating: ParentalControlRating | undefined,
    profile: Profile | undefined,
) {
    return profile?.default && !profile.ratingsThresholds && userParentalRating
        ? userParentalRating
        : profile?.ratingsThresholds?.[0].ratingsThreshold;
}

export default getParentalRating;
